import headerImage from '../assets/images/header.jpg';
import ReactPixel from 'react-facebook-pixel';

const Header = () => {
  const redirectToWhatsapp = () => {
    if (process.env.NODE_ENV.trim() === 'production') {
      ReactPixel.track('AddToCart', {
        content_type: 'Phone Case',
      });
      console.log('Facebook Pixel Contact Event Integrated');
    }
    window.open(
      'https://wa.me/6287867661084?text=Halo%20kak%2C%20saya%20mau%20order%20case',
    );
  };

  return (
    <section className='h-100' style={{ minHeight: '40rem' }}>
      <img src={headerImage} loading='lazy' className='h-100 w-auto' alt='' />

      <div className='-mt-10 pb-8 text-center'>
        <button
          onClick={redirectToWhatsapp}
          className='rounded-full primary-color shadow-md secondary-bg py-3 text-xl px-20'>
          PESAN SEKARANG
        </button>
      </div>
    </section>
  );
};

export default Header;
